export const LatestPostsImageConfig = {
  xl: {
    main: { width: 268, height: 403 },
    alt: { width: 268, height: 403 },
  },
  lg: {
    main: { width: 217, height: 271 },
    alt: { width: 217, height: 271 },
  },
  md: {
    main: { width: 200, height: 250 },
    alt: { width: 200, height: 250 },
  },
  sm: {
    main: { width: 200, height: 180 },
    alt: { width: 200, height: 180 },
  },
  xs: {
    main: { width: 435, height: 315 },
    alt: { width: 144, height: 100 },
  },
};
